import Bridge from 'common/network/bridge';

export default Bridge.connect('classic');



// WEBPACK FOOTER //
// ./app/scripts/network/classic-bridge.ts